import React from 'react';

import appIcon from '../static/img/icon-app.png'; 
import { useTranslation } from 'react-i18next';

 

function ScaricaButton() {
  const { t } = useTranslation();
  return (
    <>
      <div className="box-navigation app-download">
          <div className="text">
            <h4>{t('Download_app')}</h4>
            <p>{t('and_get_many_rewards_and_offers')}</p>
          </div>
          <img src="/assets/img/icon-app.png" alt="App Icon" />
      </div>
    </> 
  );
}

export default ScaricaButton;
